class productPageScript {
    constructor() {
        this.init();
    }

    checkStickyImage =() => {
        if (window.screen.width > 991) {
            window.addEventListener('scroll', () => {
                var el = document.querySelector('.col-lg-6.col-12.sticky-image');
                if(el != "" && el != undefined) {
                    document.querySelector('.col-lg-6.col-12.sticky-image img').style.top = `${document.querySelector('header').offsetHeight + 10}px`
                }
            })
        }
    }

    productVideoPage = () => {
        var videoEl = document.querySelector('.product--image custom-video');
        if(videoEl != undefined) {
            document.querySelector('.product--image custom-video .cta-btn .play__button').click();
            setInterval(() => {
                var iframes = document.querySelectorAll('iframe.yt_player_iframe');
                Array.prototype.forEach.call(iframes, iframe => {
                    var src = iframe.getAttribute('src');
                    var activeIfrmae = document.querySelector(`.product--image.swiper-slide-active custom-video iframe.yt_player_iframe[src="${src}"]`);
                    if(activeIfrmae != undefined && activeIfrmae != null) {
                        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'playVideo' }), '*');
                    } else {
                        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo' }), '*');
                    }
                });
            }, 1000);
        }
    }

    sliderArrowHide = () => {
        // header height issues
        var arrowHide = false;

        var slider_div  = document.querySelector('.swiper-slider.product-carousel .swiper-wrapper .swiper-slide-active')
       if (slider_div !== null){
        if (window.screen.width <= 991) {
            var countSlider = document.querySelector('.swiper-slider.product-carousel .swiper-wrapper .swiper-slide-active').getAttribute('aria-label').split(' / ')[0].toString();
            if (countSlider != 1) {
                document.querySelector('.swiper-slider.product-carousel .swiper-button-next.icon-next').style.visibility = "hidden";
                arrowHide = true;
            }   
    
            var handle = setInterval(function(){
                var countSlider = document.querySelector('.swiper-slider.product-carousel .swiper-wrapper .swiper-slide-active').getAttribute('aria-label').split(' / ')[0].toString();
                if (countSlider != 1) {
                    document.querySelector('.swiper-slider.product-carousel .swiper-button-next.icon-next').style.visibility = "hidden";
                    arrowHide = true;
                }   
    
                // When you want to cancel it:
                if (arrowHide) {
                    clearInterval(handle);
                }
            }, 1000);
        }
       }

       
    }

    init = () => {
        this.sliderArrowHide();
        this.productVideoPage();
        this.checkStickyImage();
    }
  }

  new productPageScript;

class customVideo extends HTMLElement {
    constructor() {
      super();
      this.container = this.closest('.full-video-layout');
      this.videoModal = document.getElementById('PopupModal-video');
      this.triggerVideo = this.querySelector('[data-trigger-video]');
      this.fullWidthTriggerBtn = (this.container) ? this.container.querySelector('[data-trigger-videobtn]') : null;
      this.placementType = this.getAttribute('data-placement');
      this.type = this.getAttribute('data-video-type');
      this.videoID = this.getAttribute('data-video-id');
      this.contentSection = this.querySelector('.content-section');
      this.videoSection = this.querySelector('.video-section');
      if(this.placementType == 'popup') this.videoSection = this.videoModal.querySelector('.video-section');
      if(window.screen.width <= 767 && this.dataset.mobilevideo){
        this.videoID = this.dataset.mobilevideo;
      }
      this.bindEvents();  
    }

    bindEvents(){
      this.triggerVideo.addEventListener('click', this.toggleView.bind(this));  
      if(this.placementType == 'grid') this.addEventListener('focusout', this.focusOut.bind(this));

      if(this.fullWidthTriggerBtn) {
        this.fullWidthTriggerBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.triggerVideo.dispatchEvent(new Event('click'));
        });
      }
    }
  
    /**
     * Focus Out Event to close drawer
     *
     * @param {event} Event instance
     */
    focusOut(event){
      if(this.placementType == 'popup' && this.classList.contains('show--video')) this.toggleView();
    }

    toggleView(){
      let isOpen = this.classList.contains('show--video');
      if(isOpen){
        this.videoSection.innerHTML = '';
        this.classList.remove('show--video');
        if(this.container) this.container.classList.remove('playing--video');
      }else{
        const videoElement = this._buildVideo();
        this.videoSection.appendChild(videoElement);
        this.classList.add('show--video');
        if(this.placementType == 'popup'){ openModal(this.videoModal, this.triggerVideo)}
        else if(this.container){ this.container.classList.add('playing--video');}
      }  
    }

    _buildVideo(){
      let video;
      if(window.screen.width <= 767 && this.dataset.mobilevideo){
        this.videoID = this.dataset.mobilevideo;
      }
      if(this.type == 'local'){
        video = document.createElement('video');
        video.src = this.videoID;
        video.autoplay = this.dataset.autoplay;
        video.controls = this.dataset.controls;
        video.muted = this.dataset.muted;
        video.loop = this.dataset.loop;
        video.width = '600';
      }else if(this.type == 'youtube'){
        video = document.createElement( "iframe" );
        video.setAttribute( "allowfullscreen", "" );
        video.setAttribute( "frameborder", "0" );
        video.setAttribute( "id", "youtube_player" );
        video.setAttribute( "class", "yt_player_iframe" );
        video.setAttribute( "src", "https://www.youtube.com/embed/"+ this.videoID +`?rel=0&enablejsapi=1&showinfo=0&autoplay=1&mute=1&controls=1&loop=1&playlist=${this.videoID}` );
      }else if(this.type == 'vimeo'){
        video = document.createElement( "iframe" );
        video.setAttribute( "allowfullscreen", "" );
        video.setAttribute( "frameborder", "0" );
        video.setAttribute( "class", "yt_player_iframe" );
        video.setAttribute( "id", "vemio_player" );
        video.setAttribute( "src", "https://player.vimeo.com/video/"+ this.videoID + `?rel=0&enablejsapi=1&showinfo=0&autoplay=1&mute=1&controls=1&loop=1&playlist=${this.videoID}`);
      }
      return video;
    }
}
customElements.define("custom-video", customVideo);




/**

* Tab HTML

*/

class customTabs extends HTMLElement {

    constructor() {
  
      super();
  
  
  
      this.tabLinks = this.querySelectorAll('.tablink');
  
      this.tabContainers = this.querySelectorAll('.tabcontent');
  
  
  
      this.tabLinks.forEach( link => link.addEventListener('click', this.toggleTabs.bind(this)));
  
    }
  
  
  
    /**
  
     * Focus Out Event to close drawer
  
     *
  
     * @param {event} Event instance
  
     */
  
    focusOut(event){
  
      
  
    }
  
  
  
    /**
  
     * Escape Key Press to close drawer when focus is within the container
  
     *
  
     * @param {event} Event instance
  
     */
  
    onKeyUp(event) {
  
      if(event.code.toUpperCase() !== 'ESCAPE') return;
  
    }
  
  
  
    /**
  
     * Toggle Tabs on link click
  
     *
  
     * @param {event} Event instance
  
     */
  
    toggleTabs(event){
  
      event.preventDefault();
  
      event.stopPropagation();
  
      const currentTab = event.currentTarget;
  
      const tabLink = currentTab.querySelector('[data-toggle="tab"]');
  
      const tabContainer = document.querySelector(tabLink.dataset.tabcontent);
  
  
  
      this.openTab(currentTab, tabContainer)
  
  
  
      // let isOpen = currentTab.classList.contains('open');
  
      // isOpen ? this.closeTab(currentTab, tabContainer) : this.openTab(currentTab, tabContainer);
  
    }
  
  
  
    /**
  
     * Open Tab Container
  
     *
  
     * @param {Node} currentTab Tab Container Open link
  
     * @param {Node} tabContainer Tab Container to open
  
     */
  
    openTab(currentTab, tabContainer) {
  
  
  
      this.tabContainers.forEach(container => {
  
        container.classList.remove('open');
  
        const linkEle = document.querySelector('.tablink a[data-toggle="tab"][data-tabcontent="#'+container.id+'"]');
  
        if(linkEle){
  
          linkEle.setAttribute('aria-expanded', false);
  
          if(linkEle.closest('.tablink')){ linkEle.closest('.tablink').classList.remove('open');}
  
        }
  
      });
  
      currentTab.classList.add('open');
  
      currentTab.querySelector('[data-toggle="tab"]').setAttribute('aria-expanded', true);
  
      tabContainer.classList.add('open');
  
    }
  
  
  
    /**
  
     * Close Tab Container
  
     *
  
     * @param {Node} currentTab Tab Container link
  
     * @param {Node} tabContainer Tab Container to close
  
     */
  
    closeTab(currentTab, tabContainer) {
  
      currentTab.classList.remove('open');
  
      currentTab.querySelector('[data-toggle="tab"]').setAttribute('aria-expanded', false);
  
      tabContainer.classList.remove('open');
  
    }
  
  }
  
  customElements.define("custom-tabs", customTabs);
  
  
  
  /**
  
  * Accordion HTML
  
  */
  
  class customAccordion extends HTMLElement {
  
    constructor() {
  
      super();
  
  
  
      this.accordionType = this.dataset.accordiontype;
  
      this.toggleBtns = this.querySelectorAll('.accordion__Toggle');
  
  
  
      this.toggleBtns.forEach(button => button.addEventListener('click', this.toggleAccordionBlock.bind(this)));
  
    }
  
  
  
    /**
  
     * Focus Out Event to close drawer
  
     *
  
     * @param {event} Event instance
  
     */
  
    focusOut(event){
  
      
  
    }
  
  
  
    /**
  
     * Escape Key Press to close drawer when focus is within the container
  
     *
  
     * @param {event} Event instance
  
     */
  
    onKeyUp(event) {
  
      if(event.code.toUpperCase() !== 'ESCAPE') return;
  
    }
  
  
  
    /**
  
     * Toggle Tabs on link click
  
     *
  
     * @param {event} Event instance
  
     */
  
     toggleAccordionBlock(event){
  
      event.preventDefault();
  
      const toggleBtn = event.currentTarget;
  
      const targetContainer = toggleBtn.parentNode;
  
      const isOpen = targetContainer.classList.contains('open');
  
      isOpen ? this.closeAccordionBlock(toggleBtn) : this.openAccordionBlock(toggleBtn);
  
    }
  
  
  
    /**
  
     * Open Tab Container
  
     *
  
     * @param {Node} toggleBtn Accordion Block Open link
  
     */
  
     openAccordionBlock(toggleBtn) {
  
      let targetContainer = toggleBtn.parentNode;
  
      toggleBtn.setAttribute('aria-expanded', true);
  
      Utility.toggleElement(targetContainer, 'open');
  
      if(this.accordionType == 'single'){
  
        let siblingBlocks = targetContainer.parentNode.querySelectorAll('.accordion__container');
  
        siblingBlocks.forEach(element => {
  
          if(element == targetContainer){ return; }
  
          element.classList.remove('open');
  
          element.querySelector('.accordion__block').classList.remove('open');
  
          element.querySelector('.accordion__toggle').setAttribute('aria-expanded', false);
  
        });
  
      }
  
      Utility.trapFocus(targetContainer);
  
    }
  
  
  
    /**
  
     * Close Tab Container
  
     *
  
     * @param {Node} currentTab Tab Container link
  
     * @param {Node} tabContainer Tab Container to close
  
     */
  
     closeAccordionBlock(toggleFilterBtn) {
  
      const targetContainer = toggleFilterBtn.parentNode;
  
      toggleFilterBtn.setAttribute('aria-expanded', false);
  
      Utility.toggleElement(targetContainer, 'close');
  
      Utility.removeTrapFocus(targetContainer);
  
    }
  
  }
  
  customElements.define("custom-accordion", customAccordion);